module.exports = __webpack_public_path__ + "static/media/radial_ill_inversed.35f3514d.png";